var _rect, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircularBorderActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.805786,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.8058,
    r: 12,
    fill: "#99B7D7",
    stroke: "white",
    strokeDasharray: "2 2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBorderActive);
export default __webpack_public_path__ + "static/media/circular-border-active.883922fcd8a52a6c83f2c76b47b94a27.svg";
export { ForwardRef as ReactComponent };